<script setup>
import Card from '@/Components/Card/Card.vue';
import PrivacyDetailCard from '@/Pages/DomainScore/Partials/DetailedReport/Privacy/PrivacyDetailCard.vue';
import BrandingDetailedCard from '@/Pages/DomainScore/Partials/DetailedReport/Branding/BrandingDetailedCard.vue';
import ImpersonationDetailCard from '@/Pages/DomainScore/Partials/DetailedReport/Impersonation/ImpersonationDetailCard.vue';
import OutlinedButton from '@/Components/Button/OutlinedButton.vue';
import { inject } from 'vue';
import CommonDetailCard from '@/Pages/DomainScore/Partials/DetailedReport/Common/CommonDetailCard.vue';
import PrimaryButton from '@/Components/Button/PrimaryButton.vue';
import { Link } from '@inertiajs/vue3';
import TextButton from '@/Components/Button/TextButton.vue';
import { usePage } from '@inertiajs/vue3';
import { useI18n } from 'vue-i18n';
import { downloadReport } from '@/Common/DownloadReport.js';
import {
  TOOL_DOMAIN_SCORE,
  captureReportDownloaded
} from '@/Common/Posthog.js';

const { t } = useI18n();
const page = usePage();
const branding = page.props.branding;
const domain = inject('domain');
const layout = inject('layout');

const download = () => {
  void downloadReport({
    url: route('score.export', [domain]),
    filename: `${t('domain_score.messages.report_filename', { domain })}.pdf`
  }).then((downloadStarted) => {
    if (downloadStarted) {
      captureReportDownloaded({
        tool: TOOL_DOMAIN_SCORE,
        testedDomain: domain
      });
    }
  });
};

defineEmits(['emailReport']);
</script>

<template>
  <div class="mt-6 flex flex-col gap-6 md:mt-8 md:gap-8">
    <Card class="bg-white-opacity">
      <ImpersonationDetailCard />
    </Card>
    <Card class="bg-white-opacity">
      <PrivacyDetailCard />
    </Card>
    <Card class="bg-white-opacity">
      <BrandingDetailedCard />
    </Card>
    <Card class="bg-white-opacity">
      <CommonDetailCard />
    </Card>
    <div
      v-if="layout === 'web'"
      class="flex flex-col items-center gap-4 sm:flex-row-reverse"
    >
      <PrimaryButton
        v-if="branding?.email_report"
        @click="$emit('emailReport')"
        datadog-action-name="Email Report - bottom"
      >
        {{ $t('domain_score.partials.detailed_report.email_report') }}
      </PrimaryButton>
      <OutlinedButton
        v-if="branding?.download_report"
        @click="download"
        datadog-action-name="Download Report - detail view"
      >
        {{ $t('domain_score.partials.detailed_report.download_report') }}
      </OutlinedButton>
      <Link :href="route('domain-analysis.show', [domain])">
        <TextButton>
          {{ $t('domain_score.partials.detailed_report.analyze_domain') }}
        </TextButton>
      </Link>
    </div>
  </div>
</template>
